import React, { useEffect, useState } from 'react'
import { api } from '../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import Loader from '../components/Loader'
import { useNavigate } from 'react-router-dom'

const UserCarts = () => {
    const [carts, setCarts] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(null)

    useEffect(() => {
        const getCarts = async () => {
            try {
                setIsLoading(true)
                const response = await api.get("/stores/carts", { params: { page } })
                setCarts(response.data)
                setHasMore(response.hasMore)
            } catch (error) {
                toast.error(error.response.data.message)
            }
        }
    }, [])

    const navigate = useNavigate()
    return (
        <div>
            <div className="store-user-carts-list">
                <h5>Carts</h5>

                {isLoading && <Loader />}

                {!isLoading && carts.length === 0 && (
                    <p className="not-found-msg">
                        No carts found
                    </p>
                )}

                {carts.length > 0 && (
                    <table>
                        <thead>
                            <tr>
                                <th>Cart Name</th>
                                <th>Description</th>
                                <th>Items</th>
                                <th>Orders</th>
                                <th>Cart Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {carts.map(cart => (
                                <tr
                                    key={cart._id}
                                    onClick={() =>
                                        navigate(`/b/${cart.store.name}/carts/${cart._id}`)
                                    }
                                >
                                    <td>{cart.name}</td>
                                    <td>{cart.description || "no description"}</td>
                                    <td>{cart.productsCount}</td>
                                    <td>{cart.orders}</td>
                                    <td>{cart.totalValue}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    )
}

export default UserCarts